import PropTypes from 'prop-types';

const headerPayloadType = PropTypes.shape({
  assetType: PropTypes.string,
  family: PropTypes.string,
  mediaType: PropTypes.string,
});

export default headerPayloadType;
